<template>
  <div class="validateEmailRegistration" style="justify-content: flex-start; margin-top: 32px;">

    <NavigationBar >
      <template v-slot:left>
        <img v-if="isSPMUser()" v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        {{ $t('register.validate_registration') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>
  
    <h1>Code eingeben</h1>
    
    <div v-if="this.userEmail">
      <p v-html="$t('register.email_validation_text', {email: this.userEmail})"></p>
    </div>
    <div v-else>
      <p>{{ $t('register.enter_email_and_validation_code') }}</p>
    </div>
    
    <form @submit.prevent="validateEmailRegistration">

      <div class="input-container">
        
        <div class="input-element registrationcode">
          <div class="stroke"></div>
          <div class="stroke"></div>
          <div class="stroke"></div>
          <div class="stroke"></div>
          <div class="stroke"></div>
          <input v-model="registrationCode" type="text" name="registrationCode" id="registrationCode" placeholder="000000" value maxlength="6" onkeyup="this.scrollLeft = 0;" onchange="this.scrollLeft = 0;"/>
        </div>

      </div>

      <div class="input-container">
  
        <div v-if="!email" class="input-element">
          <input v-model="userEmail" type="email" name="userEmail" id="userEmail" placeholder="email" value />
          <label for="userEmail">{{ $t('email') }}</label>
        </div>

      </div>
        
      <button type="submit" name="button" :disabled="registrationCode.length !== 6">
        {{ $t('register.finish_registration') }}
      </button>

    </form>
    
    <div class="forgot-password">
      <span>{{ $t('register.validation_email_not_received') }}</span>
      <a href="#" v-on:click="resendEmail" :disabled="isDisabled">{{ $t('register.resend_validation_email') }}</a>
    </div>

    <div v-if="userEmail && this.$store.getters.loggedIn" class="forgot-password" style="padding-top: 0px;">
      <span>{{ $t('register.wrong_email') }}</span>
      <a href="#" v-on:click="updateUserEmail">{{ $t('register.update_wrong_email') }}</a>
    </div>

    <div class="forgot-password" style="padding-top: 0px;">
      <span>{{ $t('register.support_questions') }}</span>
      <a href="#" v-on:click="contactSupport">{{ $t('register.contact_support') }}</a>
    </div>
    
  </div>
</template>

<script>
  
  import axios from 'axios'
  import NavigationBar from './../components/NavigationBar'
  import { API_TIMEOUT, TOAST_DURATION } from '../main'
  import Vue from 'vue'
  import validateRegistration from '@/views/ValidateRegistration.vue'
  
  export default {
    name: 'validateemailregistration',
    props: {
      email: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        registrationCode: '',
        isDisabled: false,
        userEmail: ''
      }
    },
    metaInfo: {
      title: 'Registrierungs-Code eingeben',
      meta: [
        { vmid: 'keywords', name: 'keywords', content: 'Registrierungs-Code eingeben, Anmelden, Registrierungs-Code erhalten' },
        { vmid: 'description', name: 'description', content: 'Registrierungs-Code eingeben' },
      ]
    },
    components: { NavigationBar },
    beforeCreate() {
      Vue.$log.debug('ValidateEmailRegistration beforeCreate')
    },
    created () {
      Vue.$log.debug('ValidateEmailRegistration created ')
    },
    mounted() {
      Vue.$log.debug('ValidateEmailRegistration mounted ' + this.$route.query.email + ' --- ' + this.$route.query.code)
      if (!this.isSPMUser() && this.$store.getters.loggedIn && this.$store.state.user.status === 'active') {
        this.$router.push({ name: 'dashboard' }).catch(err => {})
      }
      this.userEmail = this.email
      if(this.$route.query.email) {
        this.userEmail = this.$route.query.email
      } else if(this.$store.state.user && this.$store.state.user.email) {
        this.userEmail = this.$store.state.user.email
      }
      if(this.$route.query.code) {
        this.registrationCode = this.$route.query.code
        if(this.userEmail && this.registrationCode) {
          this.$store.dispatch('validateRegistration',
                  {
                    email: String(this.userEmail).toLowerCase(),
                    token: this.registrationCode
                  }
          ).then(() => {
            this.$toast.open({ message: this.$i18n.t('register.registration_finished'), position: 'top', duration: TOAST_DURATION, type: 'success' })
            if(this.$store.state.user && !this.$store.state.user.acceptedtos) {
              this.$router.push({ name: 'finishregistration' })
            } else if(this.$route.query.betgameid) {
              this.$router.push({ name: 'home', query: { email: this.userEmail, betgameid: this.$route.query.betgameid } })
            } else {
              this.$router.push({ name: 'home', query: { email: this.userEmail } })
            }
          })
        } else {
          alert(this.$i18n.t('register.enter_email_and_validation_code'))
        }
      }
    },
    methods: {
      contactSupport() {
        var mail = document.createElement('a')
        mail.href = 'mailto:' + encodeURIComponent('kontakt@teamtip.net') + '?subject=' + this.$i18n.t('register.contact_support_email_subject') + 
          '&body=' + this.$i18n.t('register.contact_support_email_body') + ' ' + encodeURIComponent(this.userEmail) + '%0A%0A' +
            this.$i18n.t('register.my_support_question') + '%0A%0A'
        mail.target = '_blank'
        mail.click()
      },
      updateUserEmail() {
        this.$router.push('/profilechangeemail')
      },
      resendEmail() {
        if(this.userEmail) {
          this.isDisabled = true
          const that = this
          axios.post(this.getBGValue('spmau') + '/rpc/resend_validation_email', {
            email: String(this.userEmail).toLowerCase(),
          }, { timeout: API_TIMEOUT } )
          .then(({ data }) => {
            alert(that.$i18n.t('register.email_sent'))
          }).catch(function (error) {
            //alert(that.$i18n.t('register.email_send_error'))
            if(that.$store.getters.loggedIn && that.$store.state.user && !that.$store.state.user.acceptedtos) {
              that.$router.push({ name: 'finishregistration' })
            } else if(that.$store.getters.loggedIn && that.$store.state.user) {
              that.$router.push({ name: 'mybetgames' })
            } else {
              that.$router.push({ name: 'home' })
            }
          })
        } else {
          alert(this.$i18n.t('register.enter_validation_email'))
        }
      },
      validateEmailRegistration() {
        if (this.$store.getters.loggedIn && this.$store.state.user && this.$store.state.user.state === 'active' &&
            this.userEmail && this.$store.state.user.email.toLowerCase() === this.userEmail.trim().toLowerCase()) {
          this.$toast.open({message: this.$i18n.t('register.registration_finished_good_luck'), position: 'top', duration: TOAST_DURATION, type: 'success' })
          if(this.$store.state.betgameId) {
            this.$router.push({ name: 'dashboard' }).catch(err => {
            })
          } else {
            this.$router.push({ name: 'mybetgames' }).catch(err => {
            })
          }
        } else {
          if (this.userEmail && this.registrationCode) {
            const that = this
            this.$store.dispatch('validateRegistration',
                {
                  email: String(this.userEmail).toLowerCase(),
                  token: this.registrationCode
                }
            ).then(() => {
              this.$toast.open({message: this.$i18n.t('register.registration_finished'), position: 'top', duration: TOAST_DURATION, type: 'success' })
              if (this.$store.getters.loggedIn) {
                this.$router.push({ name: 'dashboard' })
              } else {
                this.$router.push({ name: 'home' })
              }
            }).catch(function (error) {
              alert(that.$i18n.t('register.validation_error_check_email_and_password'))
              //that.$router.push({ name: 'home', query: { email: that.userEmail }})
            })
          } else {
            alert(this.$i18n.t('register.enter_email_and_validation_code'))
          }
        }
      },
      goBack() {
        if(this.$store.getters.loggedIn) {
            this.$router.push('/profile')
        } else {
          this.$router.push({ name: 'login' })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .validateEmailRegistration {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 64px);
    padding: 64px 16px 0 16px;
    margin: 0 auto;
    max-width: 400px;

    h1 {
        text-align: center;
    }

    p {
        text-align: center;
        margin-bottom: 26px;
    }

    button {
      margin-top: 16px;
    }
  }

  .input-container {
    margin-top: 16px !important;
  }

  .forgot-password {
    width: 100%;
    text-align: center;
    color: $colorGreyDark;
    padding: 20px 0;

    a {
      font-weight: 500;
      text-decoration: none;
      margin-left: 6px;
      padding: 12px 0;
    }
  }

  .input-element{
    display: flex;
    justify-content: center;
  }

  .registrationcode {
    width: calc(100% + 32px);
    position: relative;
    margin: 0 -16px;

    .stroke {
      position: absolute;
      height: 100%;
      width: 1px;
      top: 0;
      background: rgba(0,0,0,.12);

      &:nth-child(1) {
        left: calc(50% - 96px);
        @media screen and (min-width: 432px) {
          left: 16.66%;
        }
      } 

      &:nth-child(2) {
        left: calc(50% - 48px);
        @media screen and (min-width: 432px) {
          left: 33.32%;
        }
      } 

      &:nth-child(3) {
        @media screen and (min-width: 432px) {
          left: 50%;
        }
      } 

      &:nth-child(4) {
        left: calc(50% + 48px);
        @media screen and (min-width: 432px) {
          left: 66.66%;
        }
      } 

      &:nth-child(5) {
        left: calc(50% + 96px);
        @media screen and (min-width: 432px) {
          left: 83.32%;
        }
      } 
    }

    input {
      width: 290px;
      text-align: left;
      letter-spacing: 19.5px;
      font-size: 300%;
      font-weight: 600;
      font-family: 'Courier New';
      border-bottom: 0;
      padding: 24px 0 24px 20px;
      border-radius: 12px;

      @media screen and (min-width: 432px) {
        width: 100%;
        font-size: 56px;
        overflow: hidden;
        letter-spacing: 32px;
        padding: 24px 0 24px 20px;
      }

      &:hover {
        box-shadow: inset 0 0 2px 0 $colorGreyDark !important;
      }

      &:focus {
        box-shadow: inset 0 0 0 2px $colorGreyDark !important;
      }

      &::placeholder {
        opacity: .48;
      }
    }
  }

</style>
